var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegistrarF = function SvgRegistrarF(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 0c19.325 0 34.997 15.672 34.997 34.996 0 19.325-15.672 34.997-34.997 34.997C15.672 69.993 0 54.32 0 34.996 0 15.672 15.672 0 34.996 0Z",
    fill: "#247EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 0v69.993C15.672 69.993 0 54.32 0 34.996 0 15.672 15.672 0 34.996 0Z",
    fill: "#004AB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m29.303 33.45 3.314.21c2.71 0 5.341-.037 8.073-.21l.56 4.3c.296 2.236.957 3.76 3.3 4.069 5.917.776 9.584 1.761 12.179 5.593 1.998 2.94 3.666 7.419 3.178 10.985a11.75 11.75 0 0 1-.295 1.466c-6.32 6.262-15.018 10.13-24.616 10.13-9.597 0-18.296-3.868-24.615-10.13-.122-.46-.223-.949-.295-1.466-.489-3.566 1.18-8.045 3.178-10.985 2.602-3.832 6.269-4.817 12.178-5.593 2.344-.31 3.005-1.833 3.3-4.07l.56-4.298Z",
    fill: "#ECBB8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.79 39.626c.439 1.251 1.107 1.977 2.76 2.2 5.917.776 9.584 1.761 12.179 5.593 1.998 2.94 3.666 7.42 3.178 10.985a11.75 11.75 0 0 1-.295 1.467C53.292 66.132 44.594 70 34.996 70 25.4 70 16.7 66.131 10.381 59.87c-.122-.46-.223-.95-.295-1.467-.489-3.566 1.18-8.045 3.178-10.985 2.602-3.832 6.269-4.816 12.178-5.593 1.495-.201 2.3-.891 2.775-1.941l6.708 16.233 6.872-16.485-.007-.007Z",
    fill: "#5B9FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.42 41.934c5.407.769 8.843 1.833 11.309 5.47 1.998 2.941 3.666 7.42 3.178 10.986a11.752 11.752 0 0 1-.295 1.466c-6.27 6.211-14.882 10.065-24.386 10.122l3.502-6.52 6.692-21.531v.007Zm-35.039 17.93c-.122-.46-.223-.95-.295-1.467-.489-3.566 1.18-8.045 3.178-10.985 2.494-3.674 5.967-4.723 11.46-5.493l6.361 21.424 3.653 6.65A34.873 34.873 0 0 1 10.38 59.87v-.008Z",
    fill: "#DCE7ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.087 66.175-.209-4.989c-.28-6.686-.15-6.535-.89 0l-.468 4.134a41.1 41.1 0 0 0 1.567.855ZM50.949 66.154l.208-4.968c.274-6.686.151-6.535.87 0l.453 4.127c-.503.287-1.013.568-1.531.834v.007Z",
    fill: "#BBCED6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.226 29.67c1.05 2.853 2.638 5.032 4.622 6.707 3.66 3.105 4.846 3.084 8.49-.03 2.006-1.71 3.617-3.939 4.66-6.872.236.338.675.18 1.049-.1.431-.324.726-.748.97-1.251.669-1.366.97-3.279.28-4.163a1.095 1.095 0 0 0-.876-.438c.273-1.107.59-2.2.913-3.473 1.624-6.484-3.94-12.027-11.338-12.962-7.023.705-12.552 6.506-11.171 12.962.273 1.294.604 2.387.891 3.501-.28.05-.54.187-.74.417-.77.885-.432 2.797.316 4.163.273.503.604.927 1.093 1.25.28.188.59.317.84.288Z",
    fill: "#FBD9AB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.981 41.309 2.229-1.798 4.91 12.193-10.086 1.574 2.947-11.97Z",
    fill: "#F6C9D4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m43.882 41.309-2.229-1.798-4.91 12.193 10.087 1.574-2.948-11.97Z",
    fill: "#5B9FFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.155 57.628 2.861-4.055-4.63 1.15-2.544-11.934 6.262-1.48 8.734 28.677c-.201 0-.395 0-.596-.008l-2.725-1.71L24.14 57.62l.014.008Z",
    fill: "#F7FCFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m45.837 57.628-2.86-4.055 4.629 1.15 2.545-11.934-6.262-1.48-8.735 28.677c.202 0 .396 0 .597-.008l2.725-1.71 7.376-10.648-.014.008Z",
    fill: "#FBFDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.314 54.673a4.946 4.946 0 1 1 0 9.891 4.946 4.946 0 0 1 0-9.891Z",
    fill: "#58595B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.314 56.039a3.58 3.58 0 0 1 3.58 3.58 3.587 3.587 0 0 1-3.58 3.587 3.582 3.582 0 0 1-3.58-3.587 3.576 3.576 0 0 1 3.58-3.58Z",
    fill: "#C4C6C8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.675 44.17c-.302 2.674-.15 6.182.51 10.927l1.596-.223c-.64-4.608-.783-7.98-.503-10.532.108-.941.273-1.754.496-2.48l-1.768.417c-.137.59-.252 1.2-.331 1.89Z",
    fill: "#58595B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.059 43.242c.324 2.48.259 5.723-.237 10.101l1.639.208c.51-4.514.568-7.907.23-10.539-.014-.115-.036-.223-.05-.338l-1.74-.41c.057.317.115.64.165.985l-.007-.007Z",
    fill: "#3E4143"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.46 54.472c-.77-.877-1.654-1.352-2.56-1.402-.92-.043-1.826.352-2.624 1.215-1.653 1.776-2.919 5.744-2.854 12.128l1.646-.015c-.064-5.866 1-9.403 2.387-10.884.453-.489.935-.719 1.38-.69.468.022.957.31 1.424.848 1.337 1.524 2.343 4.795 2.279 9.62a34.174 34.174 0 0 0 1.625-1.007c-.094-4.767-1.223-8.117-2.704-9.806v-.007Z",
    fill: "#3E4143"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m45.061 65.579-1.646-.014a41.6 41.6 0 0 0 .093 3.378c.54-.136 1.079-.28 1.61-.445a42.15 42.15 0 0 1-.057-2.926v.007Z",
    fill: "#A7A9AC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m29.303 33.45 3.314.21c.798 0 1.589 0 2.38-.015v36.34c-9.598 0-18.297-3.867-24.616-10.129-.122-.46-.223-.949-.295-1.466-.489-3.566 1.18-8.045 3.178-10.985 2.602-3.832 6.269-4.817 12.178-5.593 2.344-.31 3.005-1.834 3.3-4.07l.56-4.298v.007Z",
    fill: "#E5A877"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 69.993c-9.597 0-18.296-3.868-24.615-10.13a12.3 12.3 0 0 1-.295-1.466c-.489-3.566 1.18-8.045 3.178-10.985 2.602-3.832 6.269-4.817 12.178-5.593 1.495-.202 2.3-.892 2.775-1.941l6.708 16.233.079-.187v14.069h-.008Z",
    fill: "#247EFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.381 59.863c-.122-.46-.223-.949-.295-1.466-.489-3.566 1.18-8.045 3.178-10.985 2.494-3.674 5.967-4.723 11.46-5.493l6.361 21.424 3.653 6.65A34.873 34.873 0 0 1 10.38 59.87v-.008Z",
    fill: "#D3E1E9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.087 66.175-.209-4.989c-.28-6.686-.15-6.535-.89 0l-.468 4.134a41.1 41.1 0 0 0 1.567.855Z",
    fill: "#A4B7C0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.226 29.67c1.05 2.853 2.638 5.032 4.622 6.707 1.776 1.51 2.97 2.279 4.148 2.315V7.088c-7.023.705-12.552 6.506-11.171 12.962.273 1.294.604 2.387.891 3.501-.28.05-.54.187-.74.417-.77.885-.432 2.797.316 4.163.273.503.604.927 1.093 1.25.28.188.59.317.84.288Z",
    fill: "#F7C996"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.981 41.309 2.229-1.798 4.91 12.193-10.086 1.574 2.947-11.97Z",
    fill: "#247EFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.155 57.628 2.861-4.055-4.63 1.15-2.544-11.934 6.262-1.48 8.734 28.677c-.201 0-.395 0-.596-.008l-2.725-1.71L24.14 57.62l.014.008Z",
    fill: "#F7FCFE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.314 54.673a4.946 4.946 0 1 1 0 9.891 4.946 4.946 0 0 1 0-9.891Z",
    fill: "#262220"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.314 56.039a3.58 3.58 0 0 1 3.58 3.58 3.587 3.587 0 0 1-3.58 3.587 3.582 3.582 0 0 1-3.58-3.587 3.576 3.576 0 0 1 3.58-3.58Z",
    fill: "#939598"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.675 44.17c-.302 2.674-.15 6.182.51 10.927l1.596-.223c-.64-4.608-.783-7.98-.503-10.532.108-.941.273-1.754.496-2.48l-1.768.417c-.137.59-.252 1.2-.331 1.89Z",
    fill: "#262220"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.247 36.887c-1.61-8.835-6.334-7.793-5.45-18.188.51-6.018 5.09-10.77 9.39-12.229 2.307-.783 5.161-.841 7.612-.108 5.471 1.632 8.563 6.427 9.504 11.388.41 2.113-.028 4.608-.337 6.549-.633 4.033-4.228 10.014-5.795 13.264 6.65-13.796-7.994-22.76-7.556-26.78-2.868 8.29-10.41 6.212-7.39 26.104h.022Z",
    fill: "#FFFAE7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.247 36.887c-1.61-8.835-6.334-7.793-5.45-18.188.51-6.018 5.09-10.77 9.39-12.229 1.164-.395 2.472-.604 3.802-.625v6.448c-.273-.568-.41-1.07-.36-1.524-2.868 8.29-10.409 6.212-7.39 26.104l.008.014Z",
    fill: "#F7E2BA"
  })));
};
export default SvgRegistrarF;